// src/context/userContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc, setDoc, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../firebase/firestore';
import { useLocation } from 'react-router-dom';

const UserContext = createContext();
export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [balance, setBalance] = useState(0);
  const [id, setId] = useState('');
  const [loading, setLoading] = useState(true);
  const [loadingTwo, setLoadingTwo] = useState(true);
  const [refBonus, setRefBonus] = useState(0);
  const [fullName, setFullName] = useState('');
  const [username, setUsername] = useState('');
  const [premium, setPremium] = useState(false);
  const [error, setError] = useState(null);
  const [openInfoThree, setOpenInfoThree] = useState(true);
  const [initialized, setInitialized] = useState(false);
  const [referrals, setReferrals] = useState([]);
  const [photoUrl, setPhotoUrl] = useState(''); // <--- добавлено

  const location = useLocation();
  const telegramUser = window.Telegram?.WebApp?.initDataUnsafe?.user;

  const fetchData = async (userId) => {
    if (!userId) return;

    try {
      const userRef = doc(db, 'telegramUsers', userId);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const data = userDoc.data();
        setBalance(data.balance || 0);
        setRefBonus(data.refBonus || 0);
        setUsername(data.username || '');
        setFullName(data.fullName || '');
        setPremium(data.isPremium || false);
        setId(data.userId);
        setReferrals(data.referrals || []);
      }
    } catch (err) {
      console.error('Ошибка при получении данных:', err);
      setError('Не удалось загрузить данные пользователя.');
    }

    setLoading(false);
  };

  const sendUserData = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    let referrerId = queryParams.get("ref")?.replace(/\D/g, "");

    if (telegramUser) {
      const { id: userId, username, first_name, last_name, is_premium, photo_url } = telegramUser;
      const finalUsername = username || `${first_name}_${userId}`;
      const fullNamed = `${first_name} ${last_name}`;
      const userRef = doc(db, 'telegramUsers', userId.toString());
      const userDoc = await getDoc(userRef);

      setPhotoUrl(photo_url || ''); // <--- добавлено

      if (!userDoc.exists()) {
        const userData = {
          userId: userId.toString(),
          username: finalUsername,
          firstName: first_name,
          lastName: last_name,
          fullName: fullNamed,
          balance: 0,
          isPremium: is_premium || false,
          lastActive: new Date(),
          refereeId: referrerId || null,
          referrals: [],
        };

        try {
          await setDoc(userRef, userData);
          if (referrerId) {
            const referrerRef = doc(db, 'telegramUsers', referrerId);
            const referrerDoc = await getDoc(referrerRef);
            if (referrerDoc.exists()) {
              await updateDoc(referrerRef, {
                referrals: arrayUnion({
                  userId: userId.toString(),
                  username: finalUsername,
                  balance: 0,
                  level: { id: 1, name: 'Bronze', imgUrl: '/bronze.webp' },
                }),
              });
            }
          }
        } catch (err) {
          console.error('Ошибка при создании пользователя:', err);
          setError('Ошибка при сохранении данных пользователя.');
          return;
        }
      }

      await fetchData(userId.toString());
      setInitialized(true);
    }
  };

  useEffect(() => {
    sendUserData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id) fetchData(id);
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <UserContext.Provider value={{
      balance, setBalance,
      id, setId,
      loading, setLoading,
      loadingTwo, setLoadingTwo,
      refBonus, setRefBonus,
      telegramUser,
      fullName, setFullName,
      username, setUsername,
      premium, setPremium,
      error, setError,
      location,
      openInfoThree, setOpenInfoThree,
      initialized, setInitialized,
      referrals, setReferrals,
      photoUrl, setPhotoUrl // <--- добавлено
    }}>
      {children}
    </UserContext.Provider>
  );
};
